"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class PremiumTrialUnavailableError extends client_library_1.ExtendableError {
    constructor(type) {
        super(`${type} premium trial unavailable`);
        this.type = type;
    }
}
exports.default = PremiumTrialUnavailableError;
